
import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from "react-router-dom";
import routes from "./index";

import MainLayout from "../layouts/MainLayout";
import { useAuth } from "../hooks/useAuth";

const LayoutWrapper = () => (
    <MainLayout>
        <Outlet />
    </MainLayout>
);

const AppRouter = () => {
    const { isAuthenticated } = useAuth();

    const publicRoutes = routes.filter(r => r.isPublic);
    const privateWithLayout = routes.filter(r => !r.isPublic && r.hasLayout);
    const privateNoLayout = routes.filter(r => !r.isPublic && !r.hasLayout);

    return (
        <Router>
            <Routes>
                {/* Public routes */}
                {publicRoutes.map(({ path, element }) => (
                    <Route key={path} path={path} element={element} />
                ))}

                {/* Private routes with layout */}
                {isAuthenticated ? (
                    <Route element={<LayoutWrapper />}>
                        {privateWithLayout.map(({ path, element }) => (
                            <Route key={path} path={path} element={element} />
                        ))}
                    </Route>
                ) : (
                    privateWithLayout.map(({ path }) => (
                        <Route key={path} path={path} element={<Navigate to="/login" replace />} />
                    ))
                )}

                {/* Private routes without layout */}
                {privateNoLayout.map(({ path, element }) => (
                    isAuthenticated
                        ? <Route key={path} path={path} element={element} />
                        : <Route key={path} path={path} element={<Navigate to="/login" replace />} />
                ))}

                <Route path="*" element={<Navigate to={isAuthenticated ? "/dashboard" : "/login"} replace />} />
            </Routes>
        </Router>
    );
};

export default AppRouter;
